// extracted by mini-css-extract-plugin
module.exports = {"pulsingDot":"liveLabelStyles_pulsingDot____9d6","pulsing-dot":"liveLabelStyles_pulsing-dot__JWuXg"};